import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbCarouselModule, NgbModalModule, NgbDropdown, NgbDropdownMenu, NgbDropdownToggle, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FooterComponent } from './components/footer/footer.component';
import { AppRoutingModule } from '../app-routing.module';
import { RouterModule } from '@angular/router';
import { ChatboxComponent } from './components/chatbox/chatbox.component';

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    ChatboxComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbCarouselModule,
    NgbModalModule,
    NgbDropdownModule,
  ],
  exports:[
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    ChatboxComponent
  ]
})
export class SharedModule { }
